import { Component, EventEmitter, Input, Output } from "@angular/core";
import { O2ODocumentInterface } from "../../interfaces/o2o-partner.interface";

@Component({
  selector: "app-document-card",
  templateUrl: "./document-card.component.html",
  styleUrls: ["./document-card.component.scss"]
})
export class DocumentCardComponent {
  @Input() document: O2ODocumentInterface;
  @Input() showViewButton = true;
  @Input() showDeleteButton = true;
  @Output() view = new EventEmitter<string>();
  @Output() toggleDelete = new EventEmitter<O2ODocumentInterface>();

  onView(): void {
    this.view.emit(this.document.documentUrl);
  }

  onToggleDelete(): void {
    this.toggleDelete.emit(this.document);
  }
}
